<template>
  <div class="orderInfo">
    <el-row>
      <el-col :span="24">
        <div v-if="order.company">{{ order.company }}</div>
        <div v-else>
          <span>未绑定公司</span>
          <el-button type="primary" icon="el-icon-circle-plus-outline" size="mini" circle
            @click="handelOrderBindCompanyOpen()"></el-button>
        </div>
      </el-col>
    </el-row>
    <el-tabs type="border-card" class="mt-10">
      <el-tab-pane label="基本信息">
        <el-row class="m-tab">
          <el-col :span="4" class="m-th">
            <el-tooltip content="订单号" placement="top"><span class="count-style">订单号</span></el-tooltip>
          </el-col>
          <el-col :span="20" class="m-td">
            <el-tooltip :content="order.order_num" placement="top"><span class="count-style">{{ order.order_num
            }}</span></el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th" v-if="order.order_reg && order.order_reg.order_reg_name === '单品'">
            <el-tooltip content="单品" placement="top"><span class="count-style">单品</span></el-tooltip>
          </el-col>
          <el-col :span="20" class="m-td" v-if="order.order_reg && order.order_reg.order_reg_name === '单品'">
            <el-tooltip :content="getMeals(mealSingles)" placement="top"><span class="count-style">{{
              getMeals(mealSingles) }}</span></el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="金额" placement="top"><span class="count-style">金额</span></el-tooltip>
          </el-col>
          <el-col :span="8" class="m-td">
            <span>{{ order.total_amount }}</span>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="园区" placement="top"><span class="count-style">园区</span></el-tooltip>
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="order.order_park" placement="top"><span class="count-style">{{ order.order_park
            }}</span></el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="订单类型" placement="top"><span class="count-style">订单类型</span></el-tooltip>
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="order.order_reg ? order.order_reg.order_reg_name : ''" placement="top"><span
                class="count-style">{{ order.order_reg ? order.order_reg.order_reg_name : '' }}</span></el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="派单时间" placement="top"><span class="count-style">派单时间</span></el-tooltip>
          </el-col>
          <el-col :span="8" class="m-td">
            <!-- <el-tooltip :content="order.assign_at" placement="top"> -->
            <span class="count-style">
              <!-- {{ order.assign_at }} -->
              <date-formatter :date-value="order.assign_at"></date-formatter>
            </span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="录入时间" placement="top"><span class="count-style">录入时间</span></el-tooltip>
          </el-col>
          <el-col :span="8" class="m-td">
            <!-- <el-tooltip :content="order.created_at" placement="top"> -->
            <span class="count-style">
              <!-- {{ order.created_at}} -->
              <date-formatter :date-value="order.created_at"></date-formatter>
            </span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="订单状态" placement="top"><span class="count-style">订单状态</span></el-tooltip>
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="order.order_status" placement="top"><span class="count-style">{{ order.order_status
            }}</span></el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="沟通状态" placement="top"><span class="count-style">沟通状态</span></el-tooltip>
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="order.chat_status" placement="top"><span class="count-style">{{ order.chat_status
            }}</span></el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="服务状态" placement="top"><span class="count-style">服务状态</span></el-tooltip>
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="order.service_status" placement="top"><span class="count-style">{{
              order.service_status
                }}</span></el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th" v-if="order.service_status === '服务完成'">
            <el-tooltip content="服务完成时间" placement="top"><span class="count-style">服务完成时间</span></el-tooltip>
          </el-col>
          <el-col :span="8" class="m-td" v-if="order.service_status === '服务完成'">
            <el-tooltip :content="order.service_completed_at" placement="top"><span class="count-style">{{
              order.service_completed_at }}</span></el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="录入人" placement="top"><span class="count-style">录入人</span></el-tooltip>
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="order.founder ? order.founder.username : ''" placement="top"><span
                class="count-style">{{ order.founder ? order.founder.username : '' }}</span></el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="顾问" placement="top"><span class="count-style">顾问</span></el-tooltip>
          </el-col>
          <el-col :span="8" class="m-td">
            <!-- <el-tooltip content="点击修改顾问" placement="top"> -->
            <!-- <el-select v-if="consultantSelect"
                v-model="consultantor" placeholder="请选择顾问" style="width: 100%" size="mini"
                filterable @change="editOrderPerson('consultant')">
                <el-option v-for="item in orderAdminusers" :key="item.id" :label="item.username"
                  :value="item.id">
                </el-option>
              </el-select> -->
            <span>{{ order.advisor ? order.advisor.username : '暂无' }}</span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="订单转化人" placement="top"><span class="count-style">订单转化人</span></el-tooltip>
          </el-col>
          <el-col :span="8" class="m-td">
            <!-- <el-tooltip content="点击修改订单转化人" placement="top"> -->
            <!-- <el-select v-if="convertSelect"
                v-model="convertor" placeholder="请选择订单转化人" style="width: 100%" size="mini"
                filterable @change="editOrderPerson('convert')">
                <el-option v-for="item in orderAdminusers" :key="item.id" :label="item.username"
                  :value="item.id">
                </el-option>
              </el-select> -->
            <span>{{ order.trans ? order.trans.username : '暂无' }}</span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="服务人员" placement="top"><span class="count-style">服务人员</span></el-tooltip>
          </el-col>
          <el-col :span="8" class="m-td">
            <!-- <el-tooltip content="点击修改订单服务人员" placement="top"> -->
            <!-- <el-select v-if="operatorSelect"
                v-model="operator" placeholder="请选择订单服务人员" style="width: 100%" size="mini"
                filterable @change="editOrderPerson('operator')">
                <el-option v-for="item in orderAdminusers" :key="item.id" :label="item.username"
                  :value="item.id">
                </el-option>
              </el-select> -->
            <span>{{ order.operator_name ? order.operator_name : '暂无' }}</span>
            <!-- </el-tooltip> -->
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="套餐" placement="top"><span class="count-style">套餐</span></el-tooltip>
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="order.combos ? order.combos.combo_name : ''" placement="top"><span
                class="count-style">{{ order.combos ? order.combos.combo_name : '' }}</span></el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="是否续费订单" placement="top"><span class="count-style">是否续费订单</span></el-tooltip>
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="order.is_renew" placement="top"><span class="count-style">{{ order.is_renew
            }}</span></el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="客户意向" placement="top"><span class="count-style">客户意向</span></el-tooltip>
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="order.intention" placement="top"><span class="count-style">{{ order.intention
            }}</span></el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="客户隶属" placement="top"><span class="count-style">客户隶属</span></el-tooltip>
          </el-col>
          <el-col :span="8" class="m-td">
            <span v-if="order.customer_belongs === 1" class="count-style">线上</span>
            <span v-else-if="order.customer_belongs === 2" class="count-style">线下</span>
            <span v-else class="count-style">未知</span>
          </el-col>
        </el-row>
        <el-row class="m-tab" style="margin-top:0.2rem">
          <el-col :span="4" class="m-th" style="height: 100px;line-height:100px">
            <el-tooltip content="收款凭证" placement="top"><span class="count-style">收款凭证</span></el-tooltip>
          </el-col>
          <el-col :span="20" class="m-td" style="height:100px;line-height:100px">
            <div style="display: inline-block;" v-for="img in order.receipt_pic" :key="img.id">
              <!-- <img :src="img.receive_url" alt="" style="width: 90px;height: 90px;margin: 0 10px;"> -->
              <el-image style="width: 90px;height: 90px;margin: 5px 0px 5px 10px;line-height:90px"
                :src="img.receive_url" :preview-src-list="srcList" fit="fill"></el-image>
            </div>
          </el-col>
        </el-row>

        <el-row class="m-tab" style="margin-top:0.2rem">
          <el-col :span="4" class="m-th" style="height: 65px;line-height:65px">
            <el-tooltip content="共享人" placement="top"><span class="count-style">共享人</span></el-tooltip>
          </el-col>
          <!-- <el-col :span="20" class="m-td">
            <el-select v-model="orderShares" multiple placeholder="请选择" style="width: 100%" size="mini" filterable @change="setOrderShare">
              <el-option v-for="item in orderAdminusers" :key="item.id" :label="item.username" :value="item.id">
              </el-option>
            </el-select>
          </el-col> -->
          <el-col :span="20" class="m-td" style="white-space:nowrap;overflow:auto;height:65px;line-height:65px">
            <el-tag :key="tag.id" v-for="tag in dynamicTags" closable :disable-transitions="false"
              @close="handleClose(tag.id)">
              {{ tag.username }}
            </el-tag>
            <el-select ref="saveTagInput" class="input-new-tag" @focus="onBlur" v-if="inputVisible"
              v-model="orderShares" multiple placeholder="请选择" style="width: 100%" size="mini" filterable
              @change="setOrderShare">
              <el-option v-for="item in orderAdminusers" :key="item.id" :label="item.username" :value="item.id">
              </el-option>
            </el-select>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+
              新增</el-button>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="系统结单理由" placement="top"><span class="count-style">系统结单理由</span></el-tooltip>
          </el-col>
          <el-col :span="8" class="m-td">
            <el-tooltip :content="order.over_order_reason" placement="top"><span class="count-style">{{
              order.over_order_reason }}</span></el-tooltip>
          </el-col>
          <el-col :span="4" class="m-th">
            <el-tooltip content="系统结单凭证" placement="top"><span class="count-style">系统结单凭证</span></el-tooltip>
          </el-col>
          <el-col :span="8" class="m-td">
            <el-link :href="order.over_order_path" target="_blank">查看凭证</el-link>
          </el-col>
        </el-row>
        <el-divider content-position="left">服务反馈</el-divider>
        <el-row>
          <el-timeline>
            <el-timeline-item v-for="schedule in schedules" :key="schedule.id" :timestamp="schedule.created_at"
              placement="top">
              <el-card>
                <h5>{{ schedule.executor }} 通过 {{ schedule.contact_type }} 进行联系 <span v-if="schedule.contact_duration">
                    沟通了
                    {{ schedule.contact_duration }} 秒</span></h5>
                <p>{{ schedule.reflect_content }}</p>
                <ul class="el-upload-list el-upload-list--picture">
                  <li class="el-upload-list__item is-success" v-for="image in schedule.images" :key="image.id">
                    <img class="el-upload-list__item-thumbnail" :src="image.url">
                    <a class="el-upload-list__item-name" @click="handleReflectPreview(image)">{{ image.name }}</a>
                  </li>
                </ul>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </el-row>
      </el-tab-pane>

      <el-tab-pane label="反馈记录">
        <feed-back :orderId="id" :type="1" :isShow="true" :cType="checkType"></feed-back>
      </el-tab-pane>

      <el-tab-pane label="电话沟通">
        <el-row>
          <el-col :span="24">
            <span>{{ order.customer_name }}</span>
            <span style="cursor: pointer"
              @click="call(order.vagary_phone_custome ? order.vagary_phone_custome : order.customer_phone)">{{
                order.customer_phone }} <i class="el-icon-phone-outline" style="color: rgb(87, 135, 255)"></i></span>
          </el-col>
        </el-row>
        <el-table :data="callPageData" size="mini" border style="width: 100%; margin-top: .2rem">
          <el-table-column label='姓名'>
            <template slot-scope="scope">
              {{ scope.row.user ? scope.row.user.username : '测试' }}
            </template>
          </el-table-column>
          <el-table-column label='主叫号码'>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.caller" placement="top">
                <span class="count-style">{{ scope.row.caller }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label='被叫号码'>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.callee" placement="top">
                <span class="count-style">{{ scope.row.callee }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label='通话状态'>
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.ul_fail_reason" :content="scope.row.ul_fail_reason" placement="top">
                <span class="count-style">{{ scope.row.ul_fail_reason }}</span>
              </el-tooltip>
              <span v-else>待处理</span>
            </template>
          </el-table-column>
          <el-table-column label='时长(秒)'>
            <template slot-scope="scope">
              <span>{{ scope.row.billsec }}</span>
              <i v-if="scope.row.record_flag === 1" style="color: #5cb6ff; font-size: .4rem; cursor: pointer;"
                class="el-icon-mic" @click="play(scope.row.file_storage, scope.row.record_file_download_url)"></i>
            </template>
          </el-table-column>
          <el-table-column label='呼叫时间'>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.fwd_start_time" placement="top">
                <span class="count-style">{{ scope.row.fwd_start_time }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label='备注'>
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.remark" :content="scope.row.remark" placement="top">
                <span class="count-style">{{ scope.row.remark }}</span>
              </el-tooltip>
              <el-button v-else icon="el-icon-plus" size="mini" circle
                @click="submitRemark(scope.row.id, scope.$index)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background class="mt-10 text-r" layout="total, prev, pager, next, jumper"
          :hide-on-single-page="false" :current-page="callPageOption.currentPage" :page-size="callPageOption.pageSize"
          :total="callPageOption.total" @current-change="handleCurrentChange">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="工单">
        <el-badge slot="label" :value="workNotCount" class="setBadge">工单</el-badge>
        <div style="display: flex;justify-content: space-between;align-items: center;margin: .2rem 0;">
          <p v-show="workOrders.length > 0" style="color: red;">注：带*的工单类型需要优先处理！</p>
          <el-button type="primary" size="mini" @click="handleOpenAddWorkOrder">提交工单</el-button>
        </div>
        <el-row>
          <el-timeline>
            <el-timeline-item v-for="(workOrder, index) in workOrders" :key="workOrder.id"
              :timestamp="workOrder.created_at" placement="top">
              <el-card>
                <div style="display: flex;justify-content: space-between;align-items: center;">
                  <span v-if="workOrder.work_type === '客诉'" style="color: red;">*工单类型：{{ workOrder.work_type }}</span>
                  <span v-else>工单类型：{{ workOrder.work_type }}</span>
                  <span>提交人：{{ workOrder.apply_name }}</span>
                </div>
                <p v-if="workOrder.work_type === '客诉'" style="color: red;">*工单内容：{{ workOrder.work_content }}</p>
                <p v-else>工单内容：{{ workOrder.work_content }}</p>
                <el-row class="mt-10">
                  <el-upload action="https://weixin.qiyehuo.com/api/upload/tyc/workOrderImg" :headers="uploadHeader"
                    ref="uploadMutiple" multiple accept="image/png, image/jpeg, image/gif"
                    :data="{ id: workOrder.id, index: index }" :on-success="handleWorkSuccess"
                    :on-preview="handleWorkPreview" :on-remove="handleWorkRemove" :file-list="workOrder.images"
                    list-type="picture-card">
                    <el-link type="primary">上传图片凭证</el-link>
                  </el-upload>
                  <div id="preview" @paste="handlePaste($event, index)" style="margin-top: .2rem;">
                    <span><i class="el-icon-s-opportunity" style="color:#FB894C"></i>点击此处 将图片按Ctrl+V
                      粘贴至此处</span>
                  </div>
                  <el-dialog :visible.sync="bigWatchDialog" append-to-body>
                    <img width="100%" :src="bigWatchUrl" alt="">
                  </el-dialog>
                </el-row>
                <el-row class="mt-10 mb-0 tr">
                  <el-button :type="workOrder.results ? 'success' : 'primary'" size="mini"
                    @click="handleWorkOrder(index, workOrder, workOrders)">处理</el-button>
                </el-row>
                <el-divider content-position="left">处理结果</el-divider>
                <el-row class="tr mt-20">
                  <h5>反馈人：{{ workOrder.feedback_name }}</h5>
                </el-row>
                <el-row class="mt-10">
                  <h5>{{ workOrder.results }}</h5>
                </el-row>
                <el-row class="mt-20">
                  <h5>{{ workOrder.execution_at }}<span class="warningText"
                      v-if="workOrder.duration > 30 * 60">(超时)</span>
                  </h5>
                </el-row>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="相关订单">
        <el-badge slot="label" :value="orderStatusCount" class="setBadge">相关订单</el-badge>
        <el-table :data="currentOrderData" style="width: 100%" border>
          <el-table-column fixed label='派单时间' width="140">
            <template slot-scope="scope">
              <date-formatter :date-value="scope.row.assign_at"></date-formatter>
            </template>
          </el-table-column>
          <el-table-column prop='order_num' label='订单号' width="330"></el-table-column>
          <el-table-column label='是否关联发票' width="105">
            <template slot-scope="scope">
               <el-tooltip v-if="scope.row.not_invoiced == 1" class="item" effect="dark" content="暂未开发票" placement="top">
                <el-button @click="
                  handInvoiceNoOpen(scope.row, scope.row.id, scope.row.company, 1)
                  " type="warning" size="mini" icon="el-icon-printer" style="padding: 2px" circle></el-button>
              </el-tooltip>
              <el-tooltip v-else-if="!scope.row.invoice_no" class="item" effect="dark" content="未关联发票号" placement="top">
                <el-button @click="
                  handInvoiceNoOpen(scope.row, scope.row.id, scope.row.company, 1, 'cur')
                  " type="info" size="mini" icon="el-icon-printer" style="padding: 2px" circle></el-button>
              </el-tooltip>
              <el-tooltip v-else class="item" effect="dark" content="已关联发票号" placement="top">
                <el-button @click="
                  handInvoiceNoOpen(scope.row, scope.row.id, scope.row.company, 2, 'cur')
                  " type="success" size="mini" icon="el-icon-printer" style="padding: 2px" circle></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label='金额' width="220">
            <template slot-scope="scope">
              <div>
                <span class="count-style">{{ scope.row.total_amount }}</span>
              </div>
              <div style="display: flex">
                <el-tooltip content="收款方式" placement="top">
                  <span class="count-style">{{
                    scope.row.money_in !== null ? scope.row.money_in.category_name : "无"
                  }}</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop='is_renew' label='是否续费'></el-table-column>
          <el-table-column label='订单类型' width="150">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.order_reg && scope.row.order_reg.order_reg_name === '单品'"
                :content="scope.row.meal_singles.length > 0 ? getMeals(scope.row.meal_singles) : ''" placement="top">
                <span class="count-style" v-if="scope.row.order_reg">{{ scope.row.order_reg.order_reg_name }}:
                  {{ getMeals(scope.row.meal_singles) }}</span>
              </el-tooltip>
              <span class="count-style" v-else>{{ scope.row.order_reg ? scope.row.order_reg.order_reg_name : ''
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label='公司' width="260">
            <template slot-scope="scope">
              <span v-if="scope.row.company">{{ scope.row.company }}</span>
              <el-button v-else type="primary" icon="el-icon-circle-plus" size="mini" circle
                @click="handelBindCompanyOpen(scope.row.id, scope.$index)"></el-button>
            </template>
          </el-table-column>
          <el-table-column :prop="'consultant' ? 'advisor.username' : 'consultant'" label='顾问'></el-table-column>
          <el-table-column prop='order_status' label='订单状态'></el-table-column>
        </el-table>

        <el-divider>相关订单</el-divider>
        <el-table :data="relationOrders" style="width: 100%" border>
          <el-table-column fixed label='派单时间' width="140">
            <template slot-scope="scope">
              <!-- <el-tooltip :content="scope.row.assign_at" placement="top"> -->
              <!-- <span class="count-style">{{ scope.row.assign_at }}</span> -->
              <date-formatter :date-value="scope.row.assign_at"></date-formatter>
              <!-- </el-tooltip> -->
            </template>
          </el-table-column>
          <el-table-column prop='order_num' label='订单号' width="330"></el-table-column>
          <el-table-column label='是否关联发票' width="105">
            <template slot-scope="scope">
               <el-tooltip v-if="scope.row.not_invoiced == 1" class="item" effect="dark" content="暂未开发票" placement="top">
                <el-button @click="
                  handInvoiceNoOpen(scope.row, scope.row.id, scope.row.company, 1)
                  " type="warning" size="mini" icon="el-icon-printer" style="padding: 2px" circle></el-button>
              </el-tooltip>
              <el-tooltip v-else-if="!scope.row.invoice_no" class="item" effect="dark" content="未关联发票号" placement="top">
                <el-button @click="
                  handInvoiceNoOpen(scope.row, scope.row.id, scope.row.company, 1, 'rea')
                  " type="info" size="mini" icon="el-icon-printer" style="padding: 2px" circle></el-button>
              </el-tooltip>
              <el-tooltip v-else class="item" effect="dark" content="已关联发票号" placement="top">
                <el-button @click="
                  handInvoiceNoOpen(scope.row, scope.row.id, scope.row.company, 2, 'rea')
                  " type="success" size="mini" icon="el-icon-printer" style="padding: 2px" circle></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label='金额' width="220">
            <template slot-scope="scope">
              <div>
                <span class="count-style">{{ scope.row.total_amount }}</span>
              </div>
              <div style="display: flex">
                <el-tooltip content="收款方式" placement="top">
                  <span class="count-style">{{
                    scope.row.money_in !== null ? scope.row.money_in.category_name : "无"
                  }}</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop='is_renew' label='是否续费'></el-table-column>
          <el-table-column label='订单类型' width="150">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.order_reg && scope.row.order_reg.order_reg_name === '单品'"
                :content="scope.row.meal_singles.length > 0 ? getMeals(scope.row.meal_singles) : ''" placement="top">
                <span class="count-style" v-if="scope.row.order_reg">{{ scope.row.order_reg.order_reg_name }}:
                  {{ getMeals(scope.row.meal_singles) }}</span>
              </el-tooltip>
              <span class="count-style" v-else>{{ scope.row.order_reg ? scope.row.order_reg.order_reg_name : ''
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label='公司' width="260">
            <template slot-scope="scope">
              <span v-if="scope.row.company">{{ scope.row.company }}</span>
              <el-button v-else type="primary" icon="el-icon-circle-plus" size="mini" circle
                @click="handelBindCompanyOpen(scope.row.id, scope.$index)"></el-button>
            </template>
          </el-table-column>
          <el-table-column :prop="'consultant' ? 'advisor.username' : 'consultant'" label='顾问'></el-table-column>
          <el-table-column prop='order_status' label='订单状态'></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="服务进度">
        <el-row>
          <el-timeline>
            <el-timeline-item :timestamp="order.verifier_at" placement="top"
              :color="order.verifier_at ? '#67c23a' : ''">
              <el-card>核名 {{ order.verifier_name }}</el-card>
            </el-timeline-item>
            <el-timeline-item :timestamp="order.declare_at" placement="top" :color="order.declare_at ? '#67c23a' : ''">
              <el-card>网报 {{ order.declarer_name }}</el-card>
            </el-timeline-item>
            <el-timeline-item :timestamp="order.signatory_at" placement="top"
              :color="order.signatory_at ? '#67c23a' : ''">
              <el-card>网签 {{ order.signatory_name }}</el-card>
            </el-timeline-item>
            <el-timeline-item :timestamp="order.license_at" placement="top" :color="order.license_at ? '#67c23a' : ''">
              <el-card>领执照 {{ order.licensee_name }}</el-card>
            </el-timeline-item>
            <el-timeline-item v-if="order.chapter === '是'" :timestamp="order.chapter_at" placement="top"
              :color="order.chapter_at ? '#67c23a' : ''">
              <el-card>刻章 {{ order.chapter_name }}</el-card>
            </el-timeline-item>
            <el-timeline-item :timestamp="order.material_at" placement="top"
              :color="order.material_at ? '#67c23a' : ''">
              <el-card>材料交接 {{ order.material_name }}</el-card>
            </el-timeline-item>
          </el-timeline>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="操作记录">
        <el-row>
          <el-timeline>
            <el-timeline-item v-for="log in logs" :key="log.id" :timestamp="log.created_at" placement="top">
              <el-card>
                <p>{{ log.log_content }}</p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="添加工单" :visible.sync="addWorkOrderVisible" width="45%" :modal="false"
      :before-close="handleAddWorkOrderClose">
      <el-form :model="workForm" :rules="rules" ref="workForm" label-width="100px">
        <el-form-item label="类型" prop="work_type">


          <!-- <el-select v-model="workForm.work_type" placeholder="请选择工单类型" clearable size="mini">
            <el-option value="退款" label="退款"></el-option>
            <el-option value="催单" label="催单"></el-option>
            <el-option value="其他" label="其他"></el-option>
            <el-option value="催客户完结" label="催客户完结"></el-option>
          </el-select> -->

          <el-radio-group v-model="workForm.work_type" size="mini">
            <el-radio-button label="客诉">客诉</el-radio-button>
            <el-radio-button label="退款">退款</el-radio-button>
            <el-radio-button label="催单">催单</el-radio-button>
            <el-radio-button label="催客户完结">催客户完结</el-radio-button>
            <el-radio-button label="其他">其他</el-radio-button>
          </el-radio-group>


        </el-form-item>
        <el-form-item label="内容" prop="work_content">
          <el-input type="textarea" v-model="workForm.work_content" placeholder="请输入工单内容"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="submitWorkForm('workForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="处理工单" :visible.sync="upWorkOrderVisible" width="45%" :modal="false"
      :before-close="handleUpWorkOrderClose">
      <el-form :model="upWorkForm" :rules="upRules" ref="upWorkForm" label-width="100px">
        <el-form-item label="处理结果" prop="results">
          <el-input type="textarea" v-model="upWorkForm.results" placeholder="请输入工单内容"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handleWorkOrderUp">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="服务公司" :visible.sync="bindCompanyVisible" width="40%" :modal="false"
      :before-close="handleBindCompanyClose">
      <div>
        <el-select v-model="bindCompanyFrom.company_id" filterable remote reserve-keyword placeholder="输入公司" size="mini"
          clearable :remote-method="remoteMethod" :loading="loading">
          <el-option v-for="company in companies" :key="company.company_name + company.id" :label="company.company_name"
            :value="company.id">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handelBindCompany">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="服务公司" :visible.sync="orderBindCompanyVisible" width="40%" :modal="false"
      :before-close="handleOrderBindCompanyClose">
      <div>
        <el-select v-model="orderCompanyBindId" filterable remote reserve-keyword placeholder="输入公司" size="mini"
          clearable :remote-method="remoteMethod" :loading="loading">
          <el-option v-for="company in companies" :key="company.company_name + company.id" :label="company.company_name"
            :value="company.id">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handelOrderBindCompany">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="备注" :visible.sync="remarkVisible" width="40%" :modal="false" :before-close="handleRemarkClose">
      <div>
        <el-input v-model="remarkFrom.remark" type="textarea" :rows="2" placeholder="请输入内容"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handelRemarkSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="播放" :visible.sync="dialogPlayVisible" :append-to-body="true"
      :before-close="dialogPlayVisibleBeforeClose">
      <el-row class="playCon">
        <el-card class="card" :body-style="{ padding: '10px' }">
          <div id="waveform" ref="waveform"></div>
        </el-card>
        <div style="padding: 10px" id="wave-timeline" ref="wave-timeline"></div>
      </el-row>
      <div class="text-c">
        <el-button type="primary" @click="playMusic" size="mini">
          <i :class="[isPlay ? 'el-icon-video-pause' : 'el-icon-video-play']"></i>
          {{ isPlay ? '暂停' : '播放' }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible3" class="el_dialogs" :append-to-body="true" width="45%">
      <div class="box_title">
        <span>客户意向</span>
        <i style="color: #4C87FC;" class="el-icon-question"></i>
      </div>
      <div class="dialog_box dialog_img">
        <img src="../assets/image/satisfy.png" />
      </div>
      <span slot="footer" class="dialog-footer">
      </span>
    </el-dialog>

    <invoice-dialog :visible="invoiceOpenDrawer" :row="rowData" :show-type="showType" :order-type="orderType"
      @close="handleInvoiceDialogClose" @update:visible="handleInvoiceVisibleUpdate" @bind-invoice="doBindInvoiceNo"
      @invoice-check="doInvoiceCheck"></invoice-dialog>
  </div>
</template>

<script>
import WaveSurfer from 'wavesurfer.js'
import Timeline from 'wavesurfer.js/dist/plugin/wavesurfer.timeline.js'
import FeedBack from 'common/FeedBack'
import DateFormatter from 'common/DateFormatter';

export default {
  name: 'OrderInfo',
  components: {
    FeedBack,
    DateFormatter,
    InvoiceDialog: () => import('@/pages/tyc_order/components/InvoiceDialog.vue')
  },
  props: {
    orderId: Number,
    checkType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      inputVisible: false,
      orderAdminusers: [],
      bigWatchDialog: false,
      bigWatchUrl: '',
      orderShares: [],
      uploadHeader: { Authorization: localStorage.token },
      id: null,
      orderBindCompanyVisible: false,
      orderCompanyBindId: null,
      company: '',
      dialogVisible3: false,
      order: {
        order_num: '',
        source: null,
        total_amount: 0,
        order_park: null,
        order_reg: null,
        assign_at: '',
        order_status: null,
        service_status: null,
        advisor: null,
        trans: null,
        combos: null,
      },
      mealSingles: [],
      reflects: [],
      schedules: [],
      reflectForm: {
        index: null,
        id: 0,
        content: '',
        contact_type: null,
        keyword_cate: null,
        keyword: [],
        is_notice: '0',
        next_contact_time: null,
        contact_duration: 0,
        satisfy: null,
        has_contacted: null
      },
      uploadedList: [],
      formData: null,
      addWorkOrderVisible: false,
      workForm: {
        work_content: '',
        work_type: null,
      },
      rules: {
        work_content: [
          { required: true, message: '请输入内容', trigger: 'blur' },
        ],
        work_type: [
          { required: true, message: '请选择工单类型', trigger: 'blur' },
        ],
      },
      workOrders: [],
      workNotCount: 0,
      relationCount: 0,
      fulfill: 0,
      upWorkForm: {
        index: null,
        id: null,
        results: '',
      },
      upWorkOrderVisible: false,
      upRules: {
        results: [{ required: true, message: '请输入内容', trigger: 'blur' }],
      },
      logs: [],
      currentOrderData: [],
      relationOrders: [],
      meals: [],
      bindCompanyFrom: {
        index: null,
        id: null,
        company_id: null,
      },
      bindCompanyVisible: false,
      companies: [],
      loading: false,
      callPageData: [],
      callPageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      remarkVisible: false,
      remarkFrom: {
        id: null,
        index: null,
        remark: '',
      },
      wavesurfer: null,
      dialogPlayVisible: false,
      isPlay: false,
      consultantSelect: false,  // 顾问
      convertSelect: false,  // 转化人
      operatorSelect: false,  // 服务人员
      consultantor: null,
      convertor: null,
      operator: null,
      srcList: [],
      keywordCates: [],
      keywords: [],
      chat_methods: [],
      invoiceOpenDrawer: false,
      showType: null,
      rowData: {},
      orderType: ''
    }
  },
  watch: {
    orderId: function (val) {
      this.id = val || null
      this.mealSingles = []
      this.reflects = []
      this.formData = new FormData()
      this.schedules = []
      this.callPageData = []
      this.callPageOption.currentPage = 1
      this.callPageOption.total = 0
      this.fulfill = 0
      this.relationCount = 0
      this.clearReflectForm()
      this.reflectForm.id = val
      this.orderAdminusers = []
      this.orderShares = []
      if (val) {
        this.getOrderInfo()
        this.getOrderShare()
      }
    },
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === 'development'
          ? ''
          : 'https://weixin.qiyehuo.com'
      },
    },
    orderStatusCount: {
      get: function () {
        return this.fulfill + '/' + this.relationCount
      },
    },
    dynamicTags() {
      let arr = []
      this.orderAdminusers.forEach((item) => {
        this.orderShares.forEach((i) => {
          if (item.id === i)
            arr.push({
              id: i,
              username: item.username,
            })
        })
      })
      return arr
    },
  },
  methods: {
    editConsultant(field) {
      if (field === 'consultant') {
        this.consultantSelect = true
      } else if (field === 'convert') {
        this.convertSelect = true
      } else if (field === 'operator_name') {
        this.operatorSelect = true
      }
    },
    editOrderPerson(field) {
      var serverId = null
      if (field === 'consultant') {
        serverId = this.consultantor
      } else if (field === 'convert') {
        serverId = this.convertor
      } else if (field === 'operator') {
        serverId = this.operator
      }
      this.$axios
        .post('api/admin/edit_order_detail', {
          order_id: this.orderId,
          serverId: serverId,
          field: field
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.consultantSelect = false
            this.convertSelect = false
            this.operatorSelect = false
            this.getOrderInfo()
            this.$parent.$parent.handelGetOrders()
            this.$message.success(data.msg)
          }
        })
        .catch()
    },
    handelKeywordCateChange() {
      this.reflectForm.keyword = []
      this.keywords = []
      // 根据分类获取关键词
      this.$axios
        .post('api/admin/process/check/get_keyword_by_cate', {
          keyword_cate_id: this.reflectForm.keyword_cate
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.keywords = data.data.result
            // this.$message.success(data.msg)
          }
        })
        .catch()
    },
    onBlur() {
      this.$refs.saveTagInput.$refs.input.blur = () => {
        this.inputVisible = false
      }
    },
    handleClose(id) {
      this.orderShares.forEach((item, index) => {
        if (item === id) this.orderShares.splice(index, 1)
      })
      this.$nextTick(() => {
        this.setOrderShare()
      })
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    setOrderShare() {
      this.$axios
        .post('api/order_com/set_adminuser_share', {
          order_id: this.orderId,
          shares: this.orderShares,
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.inputVisible = false
            this.$message.success(data.msg)
          }
        })
        .catch()
    },
    getOrderShare() {
      this.$axios
        .get('api/order_com/get_adminuser_share', {
          params: {
            order_id: this.orderId,
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.orderShares = data.data.shares
            this.orderAdminusers = data.data.admin_users
          }
        })
        .catch()
    },
    getOrderInfo() {
      this.$axios.get('/api/admin/tycOrders/info/' + this.id).then((res) => {
        let { data } = res
        if (data.code === 0) {
          this.order = data.data.tycOrder
          this.mealSingles = data.data.mealSingles
          this.reflects = data.data.reflects
          this.setSchedule(data.data.reflects)
          this.workOrders = data.data.workOrders
          this.logs = data.data.logs
          this.relationOrders = data.data.relationOrders
          let currentOrderArr = []
          currentOrderArr.push(data.data.tycOrder)
          this.currentOrderData = currentOrderArr
          this.relationCount = data.data.relationOrders.length
          this.countFulfill(data.data.relationOrders)
          this.workNotCount = data.data.workNotCount
          this.meals = data.data.meals
          //this.keywordCates = data.data.keywordCates
          //this.chat_methods = data.data.chat_methods

          this.consultantSelect = false
          this.convertSelect = false
          this.operatorSelect = false
          if (data.data.tycOrder.customer_phone) {
            this.getCallLogs(data.data.tycOrder.vagary_phone_custome ? data.data.tycOrder.vagary_phone_custome : data.data.tycOrder.customer_phone)
          }
          if (data.data.tycOrder.receipt_pic.length > 0) {
            for (let i = 0; i < data.data.tycOrder.receipt_pic.length; i++) {
              this.srcList.push(data.data.tycOrder.receipt_pic[i].receive_url)
            }
          }
        } else {
          this.$message.warning(data.msg)
        }
      })
    },
    countFulfill(relationOrders) {
      for (var i = 0; i < relationOrders.length; i++) {
        if (relationOrders[i].service_status === '服务完成') {
          this.fulfill++
        }
      }
    },
    setSchedule(reflects) {
      for (var i = 0; i < reflects.length; i++) {
        if (reflects[i].contact_type === '服务进度') {
          this.schedules.push(reflects[i])
        }

        if (this.schedules.length > 2) return
      }
    },
    handleReflectPreview(file) {
      let tempwindow = window.open('_blank')
      tempwindow.location = file.url
    },
    clearReflectForm() {
      this.reflectForm.index = null
      this.reflectForm.id = null
      this.reflectForm.content = ''
      this.reflectForm.contact_type = null
      this.reflectForm.satisfy = null
      this.reflectForm.has_contacted = null
      this.contact_duration = 0
      this.reflectForm.keyword_cate = null
      this.reflectForm.keyword = []
      this.keywords = []
      this.reflectForm.is_notice = '0'
      this.reflectForm.next_contact_time = null
    },
    fileChange(file, fileList) {
      this.uploadedList = fileList
    },
    fileRemove(file, fileList) {
      this.uploadedList = fileList
    },
    submitUpload() {
      if (!this.reflectForm.contact_type) {
        this.$message.error('请选择联系方式')
        return
      }

      if (!this.reflectForm.satisfy) {
        this.$message.error('请选择客户意向')
        return
      }

      if (!this.reflectForm.keyword_cate) {
        this.$message.error('请选择关键词分类')
        return
      }

      if (this.reflectForm.keyword.length <= 0) {
        this.$message.error('请选择关键词')
        return
      }

      if (!this.reflectForm.has_contacted) {
        this.$message.error('请选择是否与客户取得联系')
        return
      }

      if (
        this.reflectForm.contact_type === 1 &&
        !/(^[1-9]\d*$)/.test(this.reflectForm.contact_duration)
      ) {
        this.$message.error('请填写通话时长，必须为正整数')
        return
      }

      if (this.reflectForm.is_notice === '1' && !this.reflectForm.next_contact_time) {
        this.$message.error('请选择下次沟通的时间')
        return
      }

      if (!this.reflectForm.content) {
        this.$message.error('反馈内容不能为空')
        return
      }
      this.uploadedList.forEach((file) =>
        this.formData.append('file[]', file.raw)
      )
      this.formData.append('contact_type', this.reflectForm.contact_type)
      this.formData.append('satisfy', this.reflectForm.satisfy)
      this.formData.append('has_contacted', this.reflectForm.has_contacted)
      this.formData.append('contact_duration', this.reflectForm.contact_duration)
      this.formData.append('reflect_content', this.reflectForm.content)
      this.formData.append('order_id', this.reflectForm.id)

      this.formData.append('keyword_cate', this.reflectForm.keyword_cate)
      this.formData.append('keyword', this.reflectForm.keyword)
      this.formData.append('is_notice', this.reflectForm.is_notice)
      this.formData.append('next_contact_time', this.reflectForm.next_contact_time)

      this.$axios
        .post('/api/upload/tyc/reflectImg', this.formData)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.reflects.unshift(data.data)
            this.reflectForm.content = ''
            this.reflectForm.contact_type = null
            this.reflectForm.satisfy = null
            this.reflectForm.has_contacted = null
            this.reflectForm.contact_duration = 0

            this.reflectForm.keyword_cate = null
            this.reflectForm.keyword = []
            this.keywords = []
            this.reflectForm.is_notice = '0'
            this.reflectForm.next_contact_time = null

            this.uploadedList = []
            this.formData = null
            this.formData = new FormData()
            // this.pageData[this.reflectForm.index].contact_time = data.data.created_at
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleOpenAddWorkOrder() {
      if (!this.order.consultant) {
        this.$message.error('该订单没有顾问，请先分配顾问！')
        return
      }
      this.addWorkOrderVisible = true
    },
    handleAddWorkOrderClose(done) {
      this.$refs['workForm'].resetFields()
      done()
    },
    submitWorkForm(formName) {
      let params = {
        tyc_order_id: this.id,
        work_type: this.workForm.work_type,
        work_content: this.workForm.work_content,
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post('/api/admin/tycWorkOrders', params).then((res) => {
            const { data } = res
            if (data.code === 0) {
              this.workOrders.unshift(data.data)
              this.workNotCount++
              this.addWorkOrderVisible = false
              this.$refs['workForm'].resetFields()
              this.$message.success(data.msg)
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    handleWorkSuccess(res) {
      if (res.code === 0) {
        this.workOrders[res.data.index].images.push(res.data)
      } else {
        this.$message.error(res.msg)
      }
    },
    handleWorkPreview(file) {
      this.bigWatchDialog = true
      this.bigWatchUrl = file.url
    },
    handleWorkRemove(file) {
      this.$confirm('确定要删除当前图片吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let index = this.getWorkIndex(file.imagetable_id)
        if (index === false) {
          this.$message.error('请求错误，请刷新重试')
          return
        }
        this.$axios.post('/api/admin/tycImages/' + file.id).then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.imageListDel(index, file.id)
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除！',
        })
      })
    },
    getWorkIndex(imagetableTableId) {
      for (var i = 0; i < this.workOrders.length; i++) {
        if (this.workOrders[i].id === Number(imagetableTableId)) return i
      }

      return false
    },
    imageListDel(index, imgId) {
      for (var i = 0; i < this.workOrders[index].images.length; i++) {
        if (this.workOrders[index].images[i].id === imgId)
          this.workOrders[index].images.splice(i, 1)
      }
    },
    handleWorkOrder(index, row, workOrders) {

      for (let i = 0; i < workOrders.length; i++) {
        const element = workOrders[i];
        if (element.work_type === '客诉' && element.results === null && row.work_type !== '客诉') {
          this.$message.error('请优先处理客诉工单！')
          return;
        }
      }

      if (row.images.length === 0) {
        this.$message.error('请先上传凭证图片')
        return;
      }

      this.upWorkForm.id = row.id
      this.upWorkForm.index = index
      this.upWorkForm.results = row.results
      this.upWorkOrderVisible = true
    },
    handleUpWorkOrderClose(done) {
      this.upWorkForm.id = null
      this.upWorkForm.index = null
      this.$refs['upWorkForm'].resetFields()
      done()
    },
    handleWorkOrderUp() {
      this.$refs['upWorkForm'].validate((valid) => {
        if (valid) {
          this.$axios
            .put('/api/admin/tycWorkOrder/' + this.upWorkForm.id, {
              results: this.upWorkForm.results,
            })
            .then((res) => {
              const { data } = res
              if (data.code === 0) {
                this.workOrders[this.upWorkForm.index].results =
                  this.upWorkForm.results
                this.upWorkForm.id = null
                this.upWorkForm.index = null
                this.$refs['upWorkForm'].resetFields()
                this.workNotCount--
                this.upWorkOrderVisible = false
                this.$message.success(data.msg)
              } else {
                this.$message.error(data.msg)
              }
            })
        }
      })
    },
    handlePaste(event, index) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null
      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持本地')
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          file = items[i].getAsFile()
          break
        }
      }
      if (!file) {
        this.$message.error('粘贴内容非图片')
        return
      }
      this.$refs.uploadMutiple[index].handleStart(file) // 将粘贴过来的图片加入预上传队列
      this.$refs.uploadMutiple[index].submit() // 提交图片上传队列
    },
    getMeals(meals) {
      let str = ''
      for (var i = 0; i < meals.length; i++) {
        str += meals[i].item_name + '，'
      }

      return str
    },
    handelBindCompanyOpen(orderId, index) {
      this.bindCompanyFrom.id = orderId
      this.bindCompanyFrom.index = index
      this.bindCompanyVisible = true
    },
    handleClearBindCompanyFrom() {
      this.bindCompanyFrom.id = null
      this.bindCompanyFrom.index = null
      this.bindCompanyFrom.company_id = null
    },
    handleBindCompanyClose(done) {
      this.handleClearBindCompanyFrom()
      done()
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.searchCompanys(query)
        }, 200)
      } else {
        this.companies = []
      }
    },
    searchCompanys(query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query).then((res) => {
        const { data } = res
        if (data.code === 0) {
          this.companies = data.data.companies
        }
      })
    },
    handelBindCompany() {
      this.$axios
        .post('/api/admin/TycOrder/bindCompany', this.bindCompanyFrom)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.relationOrders[this.bindCompanyFrom.index].company =
              data.data.companyName
            this.handleClearBindCompanyFrom()
            this.bindCompanyVisible = false
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handelOrderBindCompanyOpen() {
      this.orderBindCompanyVisible = true
    },
    handleOrderBindCompanyClose(done) {
      this.orderCompanyBindId = null
      done()
    },
    handelOrderBindCompany() {
      if (!this.orderCompanyBindId) {
        this.$message.error('情选择绑定公司')
        return
      }

      this.$axios
        .post('/api/admin/TycOrder/bindCompany', {
          id: this.order.id,
          company_id: this.orderCompanyBindId,
        })
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.order.company = data.data.companyName
            this.order.company_id = this.orderCompanyBindId
            this.orderCompanyBindId = null
            this.orderBindCompanyVisible = false
          }
        })
    },
    getCallLogs(phone) {
      this.$axios
        .post(
          '/api/admin/tycOrders/call_logs?page=' +
          this.callPageOption.currentPage,
          { phone: phone },
          { loadingClose: true }
        )
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.callPageData = data.data.data
            this.callPageOption.total = data.data.total
          } else {
            this.$message.warning(data.msg)
          }
        })
    },
    handleCurrentChange(val) {
      this.callPageOption.currentPage = val
      this.getCallLogs(this.order.vagary_phone_custome ? this.order.vagary_phone_custome : this.order.customer_phone)
    },
    play(isStorage, url) {
      if (!url) {
        this.$message.error('录音为空')
        return
      }

      if (!isStorage) {
        window.open(url)
        return
      }

      this.$axios
        .post('/api/admin/callLogs/getObject', { filePath: url })
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.dialogPlayVisible = true
            this.waveSurferInit(data.data)
          }
        })
    },
    waveSurferInit(src) {
      this.$nextTick(() => {
        this.wavesurfer = WaveSurfer.create({
          container: this.$refs.waveform,
          barWidth: 1,
          cursorColor: 'black',
          progressColor: 'blue',
          backend: 'MediaElement',
          audioRate: '1',
          plugins: [
            Timeline.create({
              container: '#wave-timeline',
            }),
          ],
        })
        this.wavesurfer.load(src)
        let that = this
        this.wavesurfer.on('finish', function () {
          that.isPlay = false
        })
      })
    },
    playMusic() {
      this.wavesurfer.playPause.bind(this.wavesurfer)()
      this.isPlay = this.wavesurfer.isPlaying()
    },
    dialogPlayVisibleBeforeClose(done) {
      this.isPlay = false
      this.wavesurfer.destroy()
      done()
    },
    call(num) {
      if (!num) {
        this.$message.error('手机号为空')
        return
      }

      // this.$axios.post('/api/admin/call_logs/' + num).then((res) => {
      this.$axios.post('/api/admin/call_logs_new', {
        num
      }).then((res) => {
        let { data } = res
        if (data.code === 0) {
          this.$message.success('调用成功，请注意接听来电')
          setTimeout(this.getCallLogs(this.order.vagary_phone_custome ? this.order.vagary_phone_custome : this.order.customer_phone), 500)
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    submitRemark(id, index) {
      this.remarkFrom.id = id
      this.remarkFrom.index = index
      this.remarkVisible = true
    },
    clearRemarkFrom() {
      this.remarkFrom.id = null
      this.remarkFrom.index = null
      this.remarkFrom.remark = ''
    },
    handleRemarkClose(done) {
      this.clearRemarkFrom()
      done()
    },
    handelRemarkSubmit() {
      if (!(this.remarkFrom.id && this.remarkFrom.index !== null)) {
        this.$message.error('请求错误，清刷新重试')
        return
      }

      if (!this.remarkFrom.remark) {
        this.$message.error('内容不能为空')
        return
      }

      this.$axios
        .post('/api/admin/callLogs/remark', {
          id: this.remarkFrom.id,
          remark: this.remarkFrom.remark,
          type: 'order',
          typeId: this.order.id,
        })
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.callPageData[this.remarkFrom.index].remark =
              this.remarkFrom.remark
            this.clearRemarkFrom()
            this.remarkVisible = false
            this.$message.success(data.msg)
            this.$emit('changeOrder', this.order.id, data.data.contactTime)
          }
        })
    },
    handleParse(e) {
      let file = null
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf('image') > -1
      ) {
        file = e.clipboardData.items[0].getAsFile()
        let reader = new FileReader()
        reader.readAsDataURL(file)
        let that = this
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: 'ready',
            url: e.target.result,
          }

          that.uploadedList.push(fileObj)
        }
      } else {
        this.$message.warning('上传的文件必须为图片')
      }
    },
    handInvoiceNoOpen(row, id, company, type, order_type) {
      if (company === null) {
        this.$message.error("请先绑定公司后再操作！");
        return false;
      }

      // this.checked = row.not_invoiced == 1 ? true : false
      // let specialData = [];
      this.rowData = row
      this.showType = type;
      this.orderType = order_type;
      this.invoiceOpenDrawer = true;
    },
    handleInvoiceDialogClose() {
      // this.clearInvoiceDialogData()
    },
    clearInvoiceDialogData() {
      this.rowData = {}
      this.showType = null;
      this.orderType = ''
    },
    doBindInvoiceNo(order_id, order_type, is_special) {
      if (order_type == 'cur') {
        this.currentOrderData.forEach(item => {
          if (item.id == order_id) {
            item.invoice_no = 'true'
            item.is_special = is_special === true ? 1 : null
          }
        })
      } else if (order_type == 'rea') {
        this.relationOrders.forEach(item => {
          if (item.id == order_id) {
            item.invoice_no = 'true'
            item.is_special = is_special === true ? 1 : null
          }
        })
      }

      this.$emit('bind-invoice', order_id)
    },
    doInvoiceCheck(order_id, checked, order_type) {
      if (order_type == 'cur') {
        this.currentOrderData.forEach(item => {
          if (item.id == order_id) {
            item.not_invoiced = checked === true ? 1 : null
          }
        })
      } else if (order_type == 'rea') {
        this.relationOrders.forEach(item => {
          if (item.id == order_id) {
            item.not_invoiced = checked === true ? 1 : null
          }
        })
      }
      this.$emit('invoice-check')
    },
    handleInvoiceVisibleUpdate(val) {
      this.invoiceOpenDrawer = val
      if (!val) this.clearInvoiceDialogData()
    }
  },
}
</script>

<style lang="stylus" scoped>
.setBadge >>> .el-badge__content.is-fixed {
  top: 0.22rem;
  right: 0.06rem;
}

.orderInfo {
  .count-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .m-tab {
    border-top: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;
  }

  .m-th {
    height: 42px;
    line-height: 42px;
    padding: 0 5px;
    border-bottom: 1px solid #dee2e6;
    color: #909399;
    background: #fafafa;
  }

  .m-td {
    height: 42px;
    line-height: 42px;
    padding: 0 5px;
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
    border-bottom: 1px solid #dee2e6;
  }

  .mt-10 {
    margin-top: 0.2rem;
  }

  .mt-20 {
    margin-top: 0.4rem;
  }

  .tr {
    text-align: right;
  }

  .el-card__body p {
    margin-top: 0.4rem;
  }

  .el-dialog .el-select {
    width: 100%;

    .el-tag + .el-tag {
      margin-left: 10px;
    }

    .button-new-tag {
      margin-left: 10px;
      height: 32px;
      line-height: 30px;
      padding-top: 0;
      padding-bottom: 0;
    }

    .input-new-tag {
      width: 90px;
      margin-left: 10px;
      vertical-align: bottom;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/common/OrderInfo.vue